/**
 * Hjelpere for de uniforme «DefaultReportId:{ReportType}»-settingene (migrasjon 071+072).
 * Verdien i settingen er en ReportID (mal); tallet bak kolon er rapporttypen (Reports.ReportType).
 * Brukes av innstillings-UI-ene (SystemSettings, ProfileAdmin) for å vise mal-nedtrekk
 * i stedet for rå tallfelt.
 */

/**
 * Parser rapporttypen ut av en «DefaultReportId:{type}»-settingnøkkel
 * (f.eks. 'DefaultReportId:40' → 40). Null hvis nøkkelen ikke følger mønsteret.
 */
export const parseDefaultReportIdType = (settingKey: string): number | null => {
  const m = /^DefaultReportId:(\d+)$/.exec(settingKey);
  return m ? parseInt(m[1], 10) : null;
};
